import $store from '@/store'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { TabError } from '@/utils/class/TabError'
import StrUtils from '@/utils/StrUtils'
import lang from '@/lang'
import { cache } from '@/utils/cacheManager'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import { CARGO_TYPE_AI, CARGO_TYPE_SE, CARGO_TYPE_SI } from '@/class/cargo/model/utils/ChargeUtils'

export class UICustomUtil {
  /**
   * 加载UI自定义页面配置信息
   * @param path
   */
  static async loadUICustomPageInfo(path, branchId) {
    switch (path) {
      case '/Sales/SalesQuery':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_VESSEL, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_CHARGE_RECEIVABLE, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_CHARGE_PAYABLE, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_MBL, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_MBL_SPLIT, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_MBL_MERGE, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_HBL, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_HBL_SPLIT, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_HBL_MERGE, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_VIRTUAL_HBL, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_TRUCKING, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_DISCHARGING_TRUCKING, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_CUSTOMS, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_SPECIAL_GOODS, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AIR_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AIR_BOOKING_VESSEL, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SALES_INQUIRY_LIST, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AIR_BOOKING_CHARGE_RECEIVABLE, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AIR_BOOKING_CHARGE_PAYABLE, branchId }),
          $store.dispatch('uiCustom/loadPageSetList', [
            UICustomConstants.SEA_BOOKING_CHARGE_RECEIVABLE,
            UICustomConstants.SEA_BOOKING_CHARGE_PAYABLE,
            UICustomConstants.SEA_BOOKING_BASIC,
            UICustomConstants.SEA_BOOKING_VESSEL,
            UICustomConstants.SEA_BOOKING_MBL,
            UICustomConstants.SEA_BOOKING_HBL,
            UICustomConstants.SEA_BOOKING_VIRTUAL_HBL,
            UICustomConstants.SEA_BOOKING_TRUCKING,
            UICustomConstants.SEA_BOOKING_DISCHARGING_TRUCKING,
            UICustomConstants.SEA_BOOKING_CUSTOMS,
            UICustomConstants.SEA_BOOKING_SPECIAL_GOODS,
            UICustomConstants.SEA_BOOKING_FILE_HISTORY,
            UICustomConstants.AIR_BOOKING_BASIC,
            UICustomConstants.AIR_BOOKING_VESSEL,
            UICustomConstants.AIR_BOOKING_CHARGE_RECEIVABLE,
            UICustomConstants.AIR_BOOKING_CHARGE_PAYABLE
          ])
        ])
        break
      case '/SeaExport/BookingNew':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_VESSEL, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_MBL, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_MBL_SPLIT, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_MBL_MERGE, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_HBL, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_HBL_SPLIT, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_HBL_MERGE, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_VIRTUAL_HBL, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_CHARGE_RECEIVABLE, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_CHARGE_PAYABLE, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_SPECIAL_GOODS, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_CUSTOMS, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_TRUCKING, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_DISCHARGING_TRUCKING, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_CONTAINER_INFO, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_CONTAINER_INFO_MASTER, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_DOMESTIC_BILLING, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_OVERSEA_BILL, branchId }),
          $store.dispatch('uiCustom/loadPageSetList', [UICustomConstants.SEA_BOOKING_CHARGE_RECEIVABLE, UICustomConstants.SEA_BOOKING_CHARGE_PAYABLE, UICustomConstants.SEA_BOOKING_DOMESTIC_BILLING, UICustomConstants.SEA_BOOKING_OVERSEA_BILL]),
          $store.dispatch('uiCustom/loadModuleSyncSetInfo', { module: UICustomConstants.SEA_BOOKING_MODULE, branchId })
        ])
        break
      case '/AirExport/AeBooking':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AIR_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AIR_BOOKING_VESSEL, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AIR_BOOKING_CHARGE_RECEIVABLE, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AIR_BOOKING_CHARGE_PAYABLE, branchId }),
          $store.dispatch('uiCustom/loadPageSetList', [UICustomConstants.AIR_BOOKING_CHARGE_RECEIVABLE, UICustomConstants.AIR_BOOKING_CHARGE_PAYABLE])
        ])
        break
      case '/Sales/RemoteBooking':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.REMOTE_SEA_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.REMOTE_AIR_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.REMOTE_RE_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.REMOTE_RI_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AIR_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.RAILWAY_BOOKING_RE_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.RAILWAY_BOOKING_RI_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.REMOTE_BOOKING_LIST, branchId })
        ])
        break
      case '/SeaExport/BookingVerify':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_VERIFY_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_VERIFY_BOOKING_VESSEL, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_VESSEL, branchId })
        ])
        break
      case '/Clearing/FinanceManage':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_VESSEL, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AIR_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AIR_BOOKING_VESSEL, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.RAILWAY_BOOKING_RE_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.RAILWAY_BOOKING_RI_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AI_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SI_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_CHARGE_RECEIVABLE, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_CHARGE_PAYABLE, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.INTEGRATED_IC_BOOKING, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.INTEGRATED_CL_BOOKING, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.INTEGRATED_TT_BOOKING, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_DOMESTIC_BILLING, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_OVERSEA_BILL, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AIR_VERIFY_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AIR_BOOKING_CHARGE_RECEIVABLE, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AIR_BOOKING_CHARGE_PAYABLE, branchId }),
          $store.dispatch('uiCustom/loadPageSetList', [UICustomConstants.SEA_BOOKING_CHARGE_RECEIVABLE, UICustomConstants.SEA_BOOKING_CHARGE_PAYABLE, UICustomConstants.AIR_BOOKING_CHARGE_RECEIVABLE, UICustomConstants.AIR_BOOKING_CHARGE_PAYABLE,
            UICustomConstants.SEA_BOOKING_DOMESTIC_BILLING, UICustomConstants.SEA_BOOKING_OVERSEA_BILL
          ])
        ])
        break
      case '/RailwayExport/ReBooking':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.RAILWAY_BOOKING_RE_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.RAILWAY_BOOKING_RI_BASIC, branchId })
        ])
        break
      case '/AirImport/AiBooking':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AI_BOOKING_BASIC, branchId })
        ])
        break
      case '/SeaImport/Booking':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SI_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SI_BOOKING_ARRIVAL_INFO, branchId })
        ])
        break
      case '/Integrated/ICIEBooking':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.INTEGRATED_IC_BOOKING, branchId })
        ])
        break
      case '/Integrated/ICIEVerify':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.INTEGRATED_IC_BOOKING, branchId })
        ])
        break
      case '/Integrated/CLIEBooking':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.INTEGRATED_CL_BOOKING, branchId })
        ])
        break
      case '/Integrated/TTIEBooking':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.INTEGRATED_TT_BOOKING, branchId })
        ])
        break
      case '/Index/SopWorkTaskBoard/SE':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_BASIC, branchId })
        ])
        break
      case '/AirExport/AeBookingVerify':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AIR_VERIFY_BOOKING_BASIC, branchId })
        ])
        break
      case '/Information/Partner/Customer':
      case '/Information/Partner/Agent':
      case '/Information/Partner/Booking':
      case '/Information/Partner/Shipping':
      case '/Information/Partner/Airline':
      case '/Information/Partner/Customs':
      case '/Information/Partner/Warehouse':
      case '/Information/Partner/Truck':
      case '/Information/Partner/Other':
      case '/Information/Partner/Factory_Sign':
      case '/Information/Partner/All':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.COMPANY_NATIVE_CUSTOMER_VENDOR_RATING, branchId })
        ])
        break
      // 尾程商务/海外跟单详情页 - 加载与源业务类型相同的UICustom配置
      case '/DestinationBusiness/SeDetail':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_VESSEL, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_MBL, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_MBL_SPLIT, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_MBL_MERGE, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_HBL, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_HBL_SPLIT, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_HBL_MERGE, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_VIRTUAL_HBL, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_CHARGE_RECEIVABLE, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_CHARGE_PAYABLE, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_SPECIAL_GOODS, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_CUSTOMS, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_TRUCKING, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_DISCHARGING_TRUCKING, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_CONTAINER_INFO, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_CONTAINER_INFO_MASTER, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_DOMESTIC_BILLING, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SEA_BOOKING_OVERSEA_BILL, branchId }),
          $store.dispatch('uiCustom/loadPageSetList', [UICustomConstants.SEA_BOOKING_CHARGE_RECEIVABLE, UICustomConstants.SEA_BOOKING_CHARGE_PAYABLE, UICustomConstants.SEA_BOOKING_DOMESTIC_BILLING, UICustomConstants.SEA_BOOKING_OVERSEA_BILL]),
          $store.dispatch('uiCustom/loadModuleSyncSetInfo', { module: UICustomConstants.SEA_BOOKING_MODULE, branchId })
        ])
        break
      case '/DestinationBusiness/SiDetail':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SI_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.SI_BOOKING_ARRIVAL_INFO, branchId })
        ])
        break
      case '/DestinationBusiness/AeDetail':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AIR_BOOKING_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AIR_BOOKING_VESSEL, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AIR_BOOKING_CHARGE_RECEIVABLE, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AIR_BOOKING_CHARGE_PAYABLE, branchId }),
          $store.dispatch('uiCustom/loadPageSetList', [UICustomConstants.AIR_BOOKING_CHARGE_RECEIVABLE, UICustomConstants.AIR_BOOKING_CHARGE_PAYABLE])
        ])
        break
      case '/DestinationBusiness/AiDetail':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.AI_BOOKING_BASIC, branchId })
        ])
        break
      case '/DestinationBusiness/ReDetail':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.RAILWAY_BOOKING_RE_BASIC, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.RAILWAY_BOOKING_RI_BASIC, branchId })
        ])
        break
      case '/DestinationBusiness/IeDetail':
        await Promise.all([
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.INTEGRATED_IC_BOOKING, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.INTEGRATED_CL_BOOKING, branchId }),
          $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.INTEGRATED_TT_BOOKING, branchId })
        ])
        break
    }
  }
  /**
   * 获取页面配置
   * @param pageType
   * @param branchId
   * @param masterFlag 是否为主票（不传，则不区分主小票）
   * @param pagePartName 区域名称（不传，则不区分区域）
   */
  static getPageConfig(pageType, branchId, masterFlag, pagePartName) {
    const elementBlocks = []
    const elementDict = {}
    const fieldDict = {}
    const page = $store.state.uiCustom.pages.find(p => p.pageType === pageType && p.branchId === branchId)
    let getElementNameFunc = (element) => element.pagePartElement.elementName
    if (pagePartName) {
      // 处理重复的元素名称（以/分隔，前面为名称，后面为序号）
      getElementNameFunc = (element) => element.pagePartElement.elementName.split('/')[0]
    }
    if (page && page.blocks) {
      for (const block of page.blocks) {
        if (pagePartName && block.pagePart.pagePartName !== pagePartName) {
          continue
        }
        const elementBlock = {
          title: block.customLabel || block.sysLabel,
          name: block.pagePart.pagePartName,
          elementNames: [],
          position: block.pagePartPosition,
          hide: block.hide,
          width: 0
        }
        const blockWidthSetting = this.getBlockWidthSetting(block)
        if (blockWidthSetting) {
          elementBlock.width = blockWidthSetting.value
        }
        for (const element of block.uiCustomElementList) {
          const elementName = getElementNameFunc(element)
          elementBlock.elementNames.push(elementName)
          const fieldNames = []
          if (element.uiCustomFieldList) {
            for (const field of element.uiCustomFieldList) {
              fieldDict[field.fieldDict.fieldName] = {
                visible: field.isDisplay,
                masterVisible: field.masterIsDisplay,
                slaveVisible: field.slaveIdDisplay,
                isRequire: field.isRequire,
                label: field.customLabel || field.sysLabel
              }
              fieldNames.push(field.fieldDict.fieldName)
            }
          }
          const obj = {
            visible: element.isDisplay,
            masterVisible: element.masterIsDisplay,
            slaveVisible: element.slaveIdDisplay,
            isRequire: element.isRequire,
            customLabel: element.customLabel,
            label: element.customLabel || element.sysLabel,
            fieldNames,
            multipleRole: element.multipleRole,
            jobPositionFields: page.jobPositionFields,
            ownPrivilegePositionFields: page.ownPrivilegePositionFields,
            // seJobPositionFields: page.seJobPositionFields,
            // viewablePositionList: element.viewablePositionList,
            // writablePositionList: element.writablePositionList,
            positionPrivilegeViewable: element.positionPrivilegeViewable,
            positionPrivilegeWritable: element.positionPrivilegeWritable
          }
          if (typeof masterFlag === 'boolean' ? (masterFlag ? element.masterIsDisplay : element.slaveIdDisplay) : element.isDisplay) {
            obj.viewable = true
            obj.writable = true
          } else {
            obj.viewable = false
            obj.writable = false
          }
          obj.userCustomContent = element.userCustomContent ? JSON.parse(element.userCustomContent) : ''
          obj.customContent = element.customContent ? JSON.parse(element.customContent) : ''
          elementDict[elementName] = obj
        }
        elementBlocks.push(elementBlock)
      }
    }
    return { elementBlocks, elementDict, fieldDict, pageType }
  }

  /**
   * 获取block宽度配置
   * @param block
   * @returns
   */
  static getBlockWidthSetting(block) {
    const pageType = block.pagePart.pageType
    const pagePartPosition = block.pagePartPosition
    const min = 300
    const max = 400
    let value = block.width || 330
    if (value < min) {
      value = min
    } else if (value > max) {
      value = max
    }
    let result = { min, max, value }
    switch (pageType) {
      case UICustomConstants.REMOTE_SEA_BOOKING_BASIC: // 远程订舱-海运订舱-委托页签
      case UICustomConstants.REMOTE_AIR_BOOKING_BASIC: // 远程订舱-空运订舱-委托页签
      case UICustomConstants.REMOTE_RE_BOOKING_BASIC: // 远程订舱-铁路订舱-出口委托页签
      case UICustomConstants.REMOTE_RI_BOOKING_BASIC: // 远程订舱-铁路订舱-进口委托页签
      case UICustomConstants.SEA_BOOKING_BASIC: // 海运订舱-基本页签
        if (pagePartPosition === 2) {
          result = null
        }
        break
      case UICustomConstants.SEA_BOOKING_VESSEL: // 海运订舱-订舱页签
        if (pagePartPosition === 5) {
          result = null
        }
        break
      case UICustomConstants.SEA_BOOKING_MBL: // 海运订舱-MBL页签
        break
      case UICustomConstants.SEA_BOOKING_MBL_SPLIT: // 海运订舱-MBL拆单页签
      case UICustomConstants.SEA_BOOKING_MBL_MERGE: // 海运订舱-MBL并单页签
        if (pagePartPosition === 2) {
          result = null
        }
        break
      case UICustomConstants.SEA_BOOKING_HBL: // 海运订舱-HBL页签
        if (pagePartPosition === 2) {
          result = null
        }
        break
      case UICustomConstants.SEA_BOOKING_HBL_SPLIT: // 海运订舱-HBL拆单页签
      case UICustomConstants.SEA_BOOKING_HBL_MERGE: // 海运订舱-HBL并单页签
        if (pagePartPosition === 2 || pagePartPosition === 3) {
          result = null
        }
        break
      case UICustomConstants.SEA_BOOKING_VIRTUAL_HBL: // 海运订舱-形式分单页签
        if (pagePartPosition === 2) {
          result = null
        }
        break
      case UICustomConstants.SEA_BOOKING_CHARGE_RECEIVABLE: // 海运订舱-费用（应收）
        result = null
        break
      case UICustomConstants.SEA_BOOKING_CHARGE_PAYABLE: // 海运订舱-费用（应付）
        result = null
        break
      case UICustomConstants.SEA_VERIFY_BOOKING_BASIC: // 海出/订舱预审-基本页签
        if (pagePartPosition === 2) {
          result = null
        }
        break
      case UICustomConstants.SEA_VERIFY_BOOKING_VESSEL: // 海出/订舱预审-订舱页签
        if (pagePartPosition === 5) {
          result = null
        }
        break
      case UICustomConstants.SI_BOOKING_BASIC: // 海运操作-基本页签
        break
      case UICustomConstants.SI_BOOKING_ARRIVAL_INFO: // 海运操作-到港信息签
        break
      case UICustomConstants.AIR_BOOKING_BASIC: // 空运订舱-基本页签
        if (pagePartPosition === 2) {
          result = null
        }
        break
      case UICustomConstants.AIR_BOOKING_VESSEL: // 空运订舱-订舱页签
        break
      case UICustomConstants.AI_BOOKING_BASIC: // 空运操作-基本页签
        break
      case UICustomConstants.RAILWAY_BOOKING_RE_BASIC: // 铁路操作-出口基本页签
      case UICustomConstants.RAILWAY_BOOKING_RI_BASIC: // 铁路操作-进口基本页签
        if (pagePartPosition === 2) {
          result = null
        }
        break
      case UICustomConstants.SEA_BOOKING_SPECIAL_GOODS: // 海运订舱-特殊货物信息页签
        result = null
        break
      case UICustomConstants.SEA_BOOKING_CUSTOMS: // 海运订舱-报关
        result = null
        break
      case UICustomConstants.SEA_BOOKING_TRUCKING: // 海运订舱-客户门点
        result = null
        break
      case UICustomConstants.SEA_BOOKING_DISCHARGING_TRUCKING: // 海运订舱-目的港派车
        result = null
        break
      case UICustomConstants.INTEGRATED_IC_BOOKING: // 综合物流-国际卡航
        break
      case UICustomConstants.SEA_BOOKING_CONTAINER_INFO: // 海运订舱-箱货信息
        result = null
        break
      case UICustomConstants.SEA_BOOKING_DOMESTIC_BILLING: // 海运订舱-国内账单
        result = null
        break
      case UICustomConstants.SEA_BOOKING_OVERSEA_BILL: // 海运订舱-国外账单
        result = null
        break
      case UICustomConstants.AIR_VERIFY_BOOKING_BASIC: // 空出/订单预审-基本页签
        break
      case UICustomConstants.COMPANY_NATIVE_CUSTOMER_VENDOR_RATING: // 基础资料-合作伙伴-客商评分
        result = null
        break
    }
    return result
  }

  /**
   * 获取是否启用字段权限设置
   * @returns
   */
  static getEnableUICustomFieldPermissioin() {
    const enableUICustomFieldPermissioin = cache.hqConfig.get('EnableUICustomFieldPermissioin')
    if (enableUICustomFieldPermissioin === '1') {
      return true
    }
    if (enableUICustomFieldPermissioin === '0') {
      return false
    }
    // 默认启用，包括参数不存在（undefined）的情况
    return true
  }

  /**
   * 处理可读、可写权限
   * @param pageType
   * @param elementDict
   * @param job
   * @param masterFlag 是否为主票（不传，则不区分主小票）
   */
  static handleViewAndWrite(pageType, elementDict, job, masterFlag) {
    if ($store.getters.isAdmin) {
      return
    }
    if (![
      UICustomConstants.SEA_BOOKING_BASIC, UICustomConstants.SEA_VERIFY_BOOKING_BASIC, UICustomConstants.SEA_BOOKING_TRUCKING, UICustomConstants.SEA_BOOKING_CUSTOMS, UICustomConstants.SEA_BOOKING_SPECIAL_GOODS, UICustomConstants.SEA_BOOKING_DISCHARGING_TRUCKING, UICustomConstants.INTEGRATED_IC_BOOKING, UICustomConstants.INTEGRATED_CL_BOOKING, UICustomConstants.INTEGRATED_TT_BOOKING, UICustomConstants.SEA_BOOKING_VESSEL, UICustomConstants.SEA_BOOKING_MBL,
      UICustomConstants.SEA_BOOKING_MBL_SPLIT, UICustomConstants.SEA_BOOKING_MBL_MERGE, UICustomConstants.SEA_BOOKING_HBL,
      UICustomConstants.SEA_BOOKING_HBL_SPLIT, UICustomConstants.SEA_BOOKING_HBL_MERGE, UICustomConstants.SEA_BOOKING_VIRTUAL_HBL,
      UICustomConstants.SEA_BOOKING_CHARGE_RECEIVABLE, UICustomConstants.SEA_BOOKING_CHARGE_PAYABLE, UICustomConstants.SEA_BOOKING_DOMESTIC_BILLING, UICustomConstants.SEA_BOOKING_OVERSEA_BILL, UICustomConstants.AIR_VERIFY_BOOKING_BASIC, UICustomConstants.SALES_INQUIRY_LIST, UICustomConstants.REMOTE_BOOKING_LIST, UICustomConstants.AIR_BOOKING_CHARGE_RECEIVABLE, UICustomConstants.AIR_BOOKING_CHARGE_PAYABLE,
      UICustomConstants.AIR_BOOKING_BASIC, UICustomConstants.AIR_BOOKING_VESSEL, UICustomConstants.SEA_BOOKING_CONTAINER_INFO_MASTER
    ].includes(pageType)) {
      return
    }
    if (!this.getEnableUICustomFieldPermissioin()) {
      return
    }
    const userId = $store.getters.userId
    const keys = Object.keys(elementDict)
    if (keys.length === 0) {
      return
    }
    // const jobPositionFields = elementDict[keys[0]].jobPositionFields
    // const seJobPositionFields = elementDict[keys[0]].seJobPositionFields
    const ownPrivilegePositionFields = elementDict[keys[0]].ownPrivilegePositionFields
    // const positionMatchResultMap = new Map()
    let userInPosition = false // 用户是否包含在岗位中
    // if (jobPositionFields) {
    //   for (const positionField of jobPositionFields) {
    //     if (job[positionField] === userId) {
    //       positionMatchResultMap.set(positionField, true)
    //       userInPosition = true
    //     } else {
    //       positionMatchResultMap.set(positionField, false)
    //     }
    //   }
    // }
    // if (seJobPositionFields) {
    //   for (const positionField of seJobPositionFields) {
    //     if (job[positionField] === userId) {
    //       positionMatchResultMap.set(positionField, true)
    //       userInPosition = true
    //     } else {
    //       positionMatchResultMap.set(positionField, false)
    //     }
    //   }
    // }
    if (ownPrivilegePositionFields && ownPrivilegePositionFields.length > 0) {
      userInPosition = true
    }
    const isNew = job ? !job.uuid : false // 是否为新增操作
    for (const key of keys) {
      const element = elementDict[key]
      element.viewable = false
      element.writable = false
      if (typeof masterFlag === 'boolean' ? (masterFlag ? element.masterVisible : element.slaveVisible) : element.visible) {
        if (isNew || element.multipleRole || !userInPosition) {
          element.viewable = true
          element.writable = true
        } else {
          // if (element.viewablePositionList) {
          //   for (const positionField of element.viewablePositionList) {
          //     if (positionMatchResultMap.get(positionField)) {
          //       element.viewable = true
          //       break
          //     }
          //   }
          // }
          // if (element.writablePositionList) {
          //   for (const positionField of element.writablePositionList) {
          //     if (positionMatchResultMap.get(positionField)) {
          //       element.writable = true
          //       break
          //     }
          //   }
          // }
          if (element.positionPrivilegeViewable) {
            element.viewable = true
          }
          if (element.positionPrivilegeWritable) {
            element.writable = true
          }
        }
      }
    }
  }

  /**
   * 获取【是否应用总公司设置】
   * @param pageType
   * @param branchId
   */
  static getUseHqSet(pageType, branchId) {
    const page = $store.state.uiCustom.pages.find(p => p.pageType === pageType && p.branchId === branchId)
    if (page && page.blocks && page.blocks.length > 0) {
      return page.blocks[0].useHqSet
    }
    return true
  }

  /**
   * 获取模块字段配置
   * @param module
   * @param branchId
   * @param {function} fieldKeyGenerator 字段key生成器
   * @param {number} pageType 页签类型
   */
  static getModuleFieldConfig(module, branchId, fieldKeyGenerator, pageType) {
    const fieldMap = new Map()
    const pages = $store.state.uiCustom.pages.filter(p => p.module === module && p.branchId === branchId && (pageType ? p.pageType === pageType : true))
    pages.sort((a, b) => a.pageType - b.pageType)
    const isAdmin = $store.getters.isAdmin
    // 是否启用字段权限
    const enableUICustomFieldPermissioin = this.getEnableUICustomFieldPermissioin()
    for (const page of pages) {
      // 页签是否有字段权限功能
      const pageHasFieldPermission = [UICustomConstants.SEA_BOOKING_BASIC, UICustomConstants.SEA_VERIFY_BOOKING_BASIC, UICustomConstants.SEA_BOOKING_TRUCKING, UICustomConstants.SEA_BOOKING_CUSTOMS, UICustomConstants.SEA_BOOKING_SPECIAL_GOODS, UICustomConstants.INTEGRATED_IC_BOOKING, UICustomConstants.INTEGRATED_CL_BOOKING, UICustomConstants.INTEGRATED_TT_BOOKING, UICustomConstants.AIR_BOOKING_BASIC, UICustomConstants.AIR_VERIFY_BOOKING_BASIC, UICustomConstants.SALES_INQUIRY_LIST, UICustomConstants.REMOTE_BOOKING_LIST].includes(page.pageType)
      // 是否至少存在一个岗位
      const existPosition = page.ownPrivilegePositionFields && page.ownPrivilegePositionFields.length > 0
      for (const block of page.blocks) {
        for (const element of block.uiCustomElementList) {
          let isDisplay = false
          if (element.isDisplay) {
            if (isAdmin || !enableUICustomFieldPermissioin || !pageHasFieldPermission || !existPosition || element.multipleRole || element.positionPrivilegeViewable) {
              isDisplay = true
            }
          }
          if (element.uiCustomFieldList) {
            for (const field of element.uiCustomFieldList) {
              const key = fieldKeyGenerator(field)
              if (fieldMap.has(key)) {
                continue
              }
              if (!field.customLabel) {
                field.customLabel = element.customLabel
              }
              fieldMap.set(key, { ...field, isDisplay })
            }
          }
        }
      }
    }
    return fieldMap
  }

  /**
   * 处理查询条件
   * @param module
   * @param defaultSearchItems
   * @param customSearchItems
   * @param {number} pageType 页签类型
   * @param {boolean} hasRepeat 是否允许重复（字段）
   */
  static handleSearchItems(module, defaultSearchItems, customSearchItems, pageType, hasRepeat = false) {
    const fieldKeyGenerator = (field) => {
      let key = ''
      if (field.fieldDict.tableAlias !== 'none') {
        key += field.fieldDict.tableAlias + '.'
      }
      key += field.fieldDict.columnName
      return key.toLowerCase()
    }
    const fieldMap = this.getModuleFieldConfig(module, $store.getters.currentOfficeId, fieldKeyGenerator, pageType)
    if (fieldMap.size > 0 && customSearchItems) {
      // 确保customSearchItems是数组
      const customItems = Array.isArray(customSearchItems) ? customSearchItems : []
      const itemKeySet = new Set()
      for (const item of customItems) {
        const field = fieldMap.get(item.itemName.toLowerCase())
        if (field) {
          if (field.customLabel) {
            item.itemLabel = field.customLabel
          }
          if (!field.isDisplay) {
            item.action = AdvancedSearchField.REMOVE_ACTION
          }
          if (!hasRepeat) {
            fieldMap.delete(item.itemName.toLowerCase())
          }
        }
        itemKeySet.add(`${item.itemName}-${item.fieldType}`)
      }

      if (fieldMap.size > 0) {
        // 确保defaultSearchItems是数组
        const defaultItems = Array.isArray(defaultSearchItems) ? defaultSearchItems : []
        for (const item of defaultItems) {
          if (itemKeySet.has(`${item.itemName}-${item.fieldType}`)) {
            continue
          }
          const field = fieldMap.get(item.itemName.toLowerCase())
          if (field) {
            let newItem = null
            if (field.customLabel) {
              newItem = newItem || { ...item }
              newItem.itemLabel = field.customLabel
              newItem.action = AdvancedSearchField.UPDATE_ACTION
            }
            if (!field.isDisplay) {
              newItem = newItem || { ...item }
              newItem.action = AdvancedSearchField.REMOVE_ACTION
            }
            if (newItem && customSearchItems && Array.isArray(customSearchItems)) {
              customSearchItems.push(newItem)
            }
          }
        }
      }
    }
  }

  /**
   * 处理列定义
   * @param module
   * @param branchId
   * @param columnDefs
   */
  static handleColumnDefs(module, branchId, columnDefs) {
    const fieldMap = this.getModuleFieldConfig(module, branchId, field => field.fieldDict.fieldName)
    let result = []
    if (fieldMap.size > 0) {
      for (const columnDef of columnDefs) {
        const field = fieldMap.get(columnDef.field)
        if (field) {
          if (!field.isDisplay) {
            continue
          }
          if (field.customLabel) {
            columnDef.headerName = field.customLabel
          }
        }
        result.push(columnDef)
      }
    } else {
      result = [...columnDefs]
    }
    return result
  }

  /**
   * 初始化元素map
   * @param module
   * @param branchId
   * @param columnDefs
   */
  static initUiCustomElementMap(lob, branchId, uiCustomElementMap) {
    let module = null
    let pageType = null
    switch (lob) {
      case 'SE':
        module = UICustomConstants.SEA_BOOKING_MODULE
        pageType = UICustomConstants.SEA_BOOKING_BASIC
        break
      case 'SI':
        module = UICustomConstants.SI_BOOKING_MODULE
        pageType = UICustomConstants.SI_BOOKING_BASIC
        break
      case 'AE':
        module = UICustomConstants.AIR_BOOKING_MODULE
        pageType = UICustomConstants.AIR_BOOKING_BASIC
        break
      case 'AI':
        module = UICustomConstants.AI_BOOKING_MODULE
        pageType = UICustomConstants.AI_BOOKING_BASIC
        break
      case 'RE':
        module = UICustomConstants.RAILWAY_BOOKING_MODULE
        pageType = UICustomConstants.RAILWAY_BOOKING_RE_BASIC
        break
      case 'RI':
        module = UICustomConstants.RAILWAY_BOOKING_MODULE
        pageType = UICustomConstants.RAILWAY_BOOKING_RI_BASIC
        break
      case 'IE':
      case 'IC':
        module = UICustomConstants.IC_BOOKING_MODULE
        pageType = UICustomConstants.INTEGRATED_IC_BOOKING
        break
      case 'CL':
        module = UICustomConstants.CL_BOOKING_MODULE
        pageType = UICustomConstants.INTEGRATED_CL_BOOKING
        break
      case 'TT':
        module = UICustomConstants.TT_BOOKING_MODULE
        pageType = UICustomConstants.INTEGRATED_TT_BOOKING
        break
    }
    const pages = $store.state.uiCustom.pages.filter(p => p.module === module && p.pageType === pageType && p.branchId === branchId)
    for (const page of pages) {
      for (const block of page.blocks) {
        for (const element of block.uiCustomElementList) {
          uiCustomElementMap.set(element.pagePartElement.elementName, element)
        }
      }
    }
  }

  static handleUICustomColumnDefsField(module, branchId, columnField, defualtHeaderName) {
    if (!columnField || !$store.state.uiCustom.enable) {
      return defualtHeaderName
    }
    const fieldMap = new Map()
    const pages = $store.state.uiCustom.pages.filter(p => p.module === module && p.branchId === branchId)
    for (const page of pages) {
      for (const block of page.blocks) {
        for (const element of block.uiCustomElementList) {
          if (element.uiCustomFieldList) {
            for (const field of element.uiCustomFieldList) {
              if (field.fieldDict && field.fieldDict.fieldName && field.fieldDict.fieldName === columnField) {
                fieldMap.set(field.fieldDict.fieldName, field)
                break
              }
            }
          }
        }
      }
    }
    if (fieldMap.size > 0) {
      const field = fieldMap.get(columnField)
      if (field) {
        if (!field.isDisplay) {
          return defualtHeaderName
        }
        if (field.customLabel) {
          return field.customLabel
        }
      }
    }
    return defualtHeaderName
  }

  /**
   * 处理列名称和显示
   * @param {*} columnDefs
   * @param {*} elementDict
   * @param {function} labelFunction
   */
  static handleColumnLabelAndDisplay(columnDefs, elementDict, labelFunction) {
    if (!labelFunction) {
      labelFunction = (columnDef, element) => element.label
    }
    const result = []
    for (const columnDef of columnDefs) {
      const element = elementDict[columnDef.field]
      if (element) {
        if (element.viewable) {
          const newColumnDef = {
            ...columnDef,
            headerName: labelFunction(columnDef, element)
          }
          if (!element.writable) {
            if (columnDef.hasOwnProperty('editable')) {
              newColumnDef.editable = false
            } else if (columnDef.custom instanceof Object) {
              const newCustom = { ...columnDef.custom }
              newCustom.isEdit = false
              if (typeof newCustom.attrs === 'function') {
                newCustom.attrs = params => {
                  const funcResult = columnDef.custom.attrs(params)
                  if (funcResult && typeof funcResult === 'object') {
                    delete funcResult.isEditCBFunc
                    return funcResult
                  } else {
                    return {}
                  }
                }
              } else if (newCustom.attrs instanceof Object) {
                const newAttrs = { ...newCustom.attrs }
                delete newAttrs.isEditCBFunc
                newCustom.attrs = newAttrs
              }
              newColumnDef.custom = newCustom
            }
          }
          result.push(newColumnDef)
        }
      } else {
        result.push(columnDef)
      }
    }
    return result
  }

  /**
   * 校验rowData必填
   * @param {*} rowData
   * @param {*} elementDict
   * @param {*} activeName
   * @param {*} labelFunction
   * @param {*} covertValueFunc
   */
  static checkRowDataRequire(rowData, elementDict, activeName, labelFunction, covertValueFunc) {
    if (!rowData) {
      return
    }
    if (!covertValueFunc) {
      covertValueFunc = (data, field) => data[field]
    }
    for (const row of rowData) {
      for (const field in elementDict) {
        const element = elementDict[field]
        if (element && element.viewable && element.writable && element.isRequire) {
          const value = covertValueFunc(row, field)
          if (value === undefined) {
            continue
          }
          if (typeof value !== 'boolean' && StrUtils.isEmpty(value)) {
            const label = labelFunction ? labelFunction(row, element) : element.label
            throw new TabError(lang.t('Message.FieldValueCannotBeNull', [label]), activeName)
          }
        }
      }
    }
  }

  /**
   * 获取成对的费用页签类型
   * @param pageType
   * @returns
   */
  static getPairChargePageType(pageType) {
    const arPageTypes = [UICustomConstants.SEA_BOOKING_CHARGE_RECEIVABLE, UICustomConstants.AIR_BOOKING_CHARGE_RECEIVABLE]
    const apPageTypes = [UICustomConstants.SEA_BOOKING_CHARGE_PAYABLE, UICustomConstants.AIR_BOOKING_CHARGE_PAYABLE]
    let index = arPageTypes.findIndex(item => item === pageType)
    // 传入的是应收页签，应付页签通过索引从apPageTypes中获取
    if (index > -1) {
      return { arPageType: pageType, apPageType: apPageTypes[index] }
    }
    index = apPageTypes.findIndex(item => item === pageType)
    // 传入的是应付页签，应收页签通过索引从arPageTypes中获取
    if (index > -1) {
      return { arPageType: arPageTypes[index], apPageType: pageType }
    }
    // 传入的不是应收或应付页签，返回0
    return { arPageType: 0, apPageType: 0 }
  }

  /**
   * 获取费用页签设置
   * @param pageType
   * @returns
   */
  static getChargePageSet(pageType) {
    const { arPageType, apPageType } = this.getPairChargePageType(pageType)
    if (arPageType || apPageType) {
      const result = { hideTabCharge: false, arAloneShow: false, apAloneShow: false, arShowInSalesInquiry: true, apShowInSalesInquiry: false }
      const arPageSet = $store.state.uiCustom.pageSetList.find(p => p.pageType === arPageType)
      if (arPageSet) {
        Object.assign(result, JSON.parse(arPageSet.customContent))
      }
      const apPageSet = $store.state.uiCustom.pageSetList.find(p => p.pageType === apPageType)
      if (apPageSet) {
        Object.assign(result, JSON.parse(apPageSet.customContent))
      }
      return result
    }
    return {}
  }

  /**
   * 获取在销售查询中的页签显示标识
   * @param pageType
   * @returns
   */
  static getSalesInquiryPageShowFlag(pageType) {
    const pageSet = $store.state.uiCustom.pageSetList.find(p => p.pageType === pageType)
    if (pageSet) {
      const pageSetObj = JSON.parse(pageSet.customContent)
      if (pageSetObj.showInSalesInquiry === undefined) {
        return true
      }
      return pageSetObj.showInSalesInquiry
    }
    return true
  }

  /**
   * 获取国内账单页签设置
   * @param pageType
   * @returns
   */
  static getInternalBillPageSet(pageType) {
    const result = { newReceiveHide: false, newPayHide: false, editHide: false }
    const pageSet = $store.state.uiCustom.pageSetList.find(p => p.pageType === pageType)
    if (pageSet) {
      Object.assign(result, JSON.parse(pageSet.customContent))
    }
    return result
  }

  /**
   * 获取国外账单页签设置
   * @param pageType
   * @returns
   */
  static getOverseaBillPageSet(pageType) {
    const result = { newHide: false, editHide: false }
    const pageSet = $store.state.uiCustom.pageSetList.find(p => p.pageType === pageType)
    if (pageSet) {
      Object.assign(result, JSON.parse(pageSet.customContent))
    }
    return result
  }

  /**
   * 处理字段变化
   * @param module
   * @param pageType
   * @param job
   * @param fieldName
   * @param modifiedData
   */
  static handleFieldChange(module, pageType, job, fieldName, modifiedData) {
    const branchId = $store.getters.currentOfficeId
    const syncManage = $store.state.uiCustom.moduleSyncSetList.find(p => p.module === module && p.branchId === branchId)
    if (!syncManage) {
      return
    }
    const valueSyncList = syncManage.useHqSet && branchId !== 1 ? syncManage.hqUiCustomValueSyncList : syncManage.uiCustomValueSyncList
    const valueSyncItem = valueSyncList.find(p => p.sourcePage === pageType && p.sourceField === fieldName)
    if (!valueSyncItem) {
      return
    }
    const { sourcePage, sourceField, writePage, writeField, syncOnlyCreate, masterSyncSlave } = valueSyncItem
    let sourceValue
    switch (sourcePage) {
      case UICustomConstants.SEA_BOOKING_BASIC:
        sourceValue = job[sourceField]
        break
    }
    if (sourceValue === undefined) {
      return
    }
    if (syncOnlyCreate ? !job.uuid : true) {
      this.writeTargetJob(job, writePage, writeField, sourceValue)
    }
    if (masterSyncSlave && job.masterFlag && job.lclSlaves) {
      for (const slave of job.lclSlaves) {
        this.writeTargetJob(slave, writePage, writeField, sourceValue)
        // 加入到修改数据集中
        modifiedData.lclSlaves = modifiedData.lclSlaves || []
        if (!modifiedData.lclSlaves.includes(slave)) {
          modifiedData.lclSlaves.push(slave)
        }
      }
    }
  }

  /**
   * 向目标业务写入字段值
   * @param job
   * @param writePage
   * @param writeField
   * @param sourceValue
   */
  static writeTargetJob(job, writePage, writeField, sourceValue) {
    switch (writePage) {
      case UICustomConstants.SEA_BOOKING_BASIC:
        job[writeField] = sourceValue
        break
    }
  }
}
